import ThemePadding from "containers/admin/clients/client/theme-page/preview/components/theme-padding/theme-padding";
import ContentBlockPadding from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/components/content-block";

const LayoutSectionContent = ({ sectionName }: { sectionName: string }) => {
  if (sectionName === "contentArea") {
    return <ThemePadding formFieldPrefix={`layout.${sectionName}`} label="Padding (px)" />;
  } else {
    return <ContentBlockPadding />;
  }
};

export default LayoutSectionContent;
